import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import * as moment from 'moment';

import { DteGenerado } from 'src/app/interfaces/dte-generado.interface';
import { Detalle, Totales } from 'src/app/interfaces/dte.interface';
import { ProductoDte } from 'src/app/interfaces/producto-dte.interface';
import { Producto } from 'src/app/interfaces/producto.interface';
import { Venta } from 'src/app/interfaces/venta.interface';
import { SimpleApiService } from 'src/app/services/simple-api.service';
import { VentaService } from 'src/app/services/venta.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pago',
  templateUrl: './pago.component.html',
  styleUrls: ['./pago.component.css']
})
export class PagoComponent implements OnInit {

  provForm = this.fb.group({
    monto: ['', [Validators.required, Validators.min(this.service.venta)]],
    vuelto: ['']
  });

  cargando = false;
  msgBackdrop = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toast: ToastrService,
    public service: VentaService,
    public simpleApi: SimpleApiService
  ) { }

  ngOnInit(): void {
  }

  cuadroPagaCon() {
    this.provForm.controls.monto.setValue('');
    this.provForm.controls.vuelto.setValue('');
    $('#modalPago').modal({ keyboard: false });
  }

  agregarDigito(numero: string) {
    let cantidad: string = this.provForm.controls.monto.value;
    if (!cantidad) {
      cantidad = numero
    } else {
      cantidad = cantidad + numero;
    }
    this.provForm.controls.monto.setValue(Number.parseInt(cantidad, 10));
    this.calcularVuelto();
  }

  borrarDigito() {
    let cantidad: string = this.provForm.controls.monto.value.toString();
    if (!cantidad) {
      return;
    }

    if (cantidad.length === 1) {
      this.provForm.controls.monto.setValue('');
      return;
    }

    const ultIndex = cantidad.length - 1;
    cantidad = cantidad.substring(0, ultIndex);

    this.provForm.controls.monto.setValue(cantidad);
    this.calcularVuelto();
  }

  calcularVuelto() {
    let vuelto = 0;
    const pago = Number.parseInt(this.provForm.controls.monto.value, 10);

    if (this.service.venta <= pago) {

      vuelto = pago - this.service.venta;

    } else {
      vuelto = 0;
    }

    this.provForm.controls.vuelto.setValue(vuelto);
  }

  transbank() {
    this.provForm.controls.monto.setValue(this.service.venta);
    this.provForm.controls.vuelto.setValue(0);
    this.pagaCon(48);
  }

  pagaCon(formaPago: number) {
    if (this.provForm.invalid) {
      return;
    }

    $('#modalPago').modal('hide');

    if (this.service.folio.actual > this.service.folio.hasta) {
      this.toast.error('Sin Folios para la venta.');
      this.salirVenta();
      return;
    }

    this.emitirDTE(formaPago);
  }

  armarEncabezadoDTE(): any {

    const encabezado: any = {
      IdDoc: {
        TipoDTE: 39,
        Folio: 0
      },
      Emisor: {
        RUTEmisor: '15491994-5'
      },
      Receptor: {
        RUTRecep: '66666666-6',
        RznSocRecep: 'Sin Rut'
      }
    };

    return encabezado;

  }

  armarDetalleDTE(): Detalle[] {

    const detalle: Detalle[] = [];

    this.service.productos.forEach((producto: Producto) => {

      let cantidadVenta: number;

      if (producto.category === 'PANADERIA' || producto.category === 'VERDURERIA' || producto.category === 'FIAMBRERIA') {
        cantidadVenta = 1;
      } else {
        cantidadVenta = producto.cantidad;
      }

      const aux: Detalle = {
        Nombre: producto.name,
        Cantidad: cantidadVenta,
        Precio: producto.precio
      };

      detalle.push(aux);

    });

    return detalle;

  }

  armarVenta(folio: number, dte: number, xml: string, trackId: number) {
    const ventaDTE: Venta = {
      fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
      folio,
      total: this.service.venta,
      dte,
      caja: this.service.caja,
      productos: this.service.productos,
      xml,
      trackId
    };
    return ventaDTE;
  }

  salirVenta() {
    this.service.isAuthenticated = false;
    this.service.productos = [];
    this.service.venta = 0;
    this.router.navigateByUrl('/venta');
  }

  generarDte(xml: string, folio: number, detalle: Detalle[]) {

    const pago = Number.parseInt(this.provForm.controls.monto.value, 10);
    const vuelto = Number.parseInt(this.provForm.controls.vuelto.value, 10);
    const total = this.service.venta;
    const neto = Math.round(total / (1 + 0.19));
    const iva = Math.round(total - neto);

    const _detalle: ProductoDte[] = detalle.map((d: Detalle) => ({
      NmbItem: d.Nombre,
      PrcItem: d.Precio,
      QtyItem: d.Cantidad
    }));

    const dteGenerado: DteGenerado = {
      xml: xml,
      folio: folio,
      total: this.service.venta,
      fecha: moment().format('DD-MM-YYYY HH:mm:ss'),
      iva,
      neto,
      pago,
      vuelto,
      vendedor: this.service.caja.vendedor.nombre,
      impresora: this.service.impresora,
      detalle: _detalle
    };

    return dteGenerado;
  }

  async emitirDTE(formaPago: number) {

    try {
      const detalle = this.armarDetalleDTE();
      const neto = Math.round(this.service.venta / 1.19);
      const totales: Totales = {
        MontoTotal: this.service.venta,
        MontoNeto: neto,
        IVA: this.service.venta - neto
      };

      const dteJson = this.simpleApi.generarDteJson(this.service.folio.actual, totales, detalle);

      const formData = new FormData();
      formData.append('input', JSON.stringify(dteJson));
      formData.append('files', this.service.cert);
      formData.append('files', this.service.caf);

      this.msgBackdrop = 'GENERANDO XML';
      this.cargando = true;

      let xmlBlob: Blob;
      let xmlFile: File;
      let xmlString: string;
      let xml64: string;

      try {
        xmlBlob = await this.simpleApi.dteGenerar(formData);
        xmlFile = new File([xmlBlob], 'dte.xml', { type: 'text/xml' });
        xmlString = await xmlFile.text();
      } catch (error) {
        this.toast.error('No se pudo generar xml. revisa tu internet y vuelve a intentar');
        throw error;
      }

      this.msgBackdrop = 'IMPRIMIENDO BOLETA';

      try {
        xml64 = btoa(xmlString.replace(/[üéáíóúñÑÜÁÉÍÓÚ]+/g, ''));
        const dteGenerado = this.generarDte(xml64, this.service.folio.actual, detalle);
        await this.service.imprimir(dteGenerado);
      } catch (error) {
        this.toast.error('no se pudo imprimir. levanta el servicio y vuelve a intentar.');
        throw error;
      }

      this.msgBackdrop = 'GENERANDO SOBRE';

      const sobreJson = this.simpleApi.generarSobreJson();
      const formDataSobre = new FormData();
      let xmlSobre: File;
      formDataSobre.append('input', JSON.stringify(sobreJson));
      formDataSobre.append('files', this.service.cert);
      formDataSobre.append('files', xmlFile);

      try {
        const blobSobre = await this.simpleApi.envioGenerar(formDataSobre);
        xmlSobre = new File([blobSobre], 'xmlSobre.xml', { type: 'text/xml' });
      } catch (error) {
        this.toast.error('no se pudo generar sobre. revisa tu internet y vuelve a intentar.');
        throw error;
      }

      this.msgBackdrop = 'ENVIANDO SII';

      const envioJson = this.simpleApi.generarEnvioJson();
      const formDataEnvio = new FormData();
      let result: any;
      formDataEnvio.append('input', JSON.stringify(envioJson));
      formDataEnvio.append('files', this.service.cert);
      formDataEnvio.append('files', xmlSobre);

      try {
        result = await this.simpleApi.envioEnviar(formDataEnvio);
      } catch (error) {
        this.toast.error('no se pudo enviar al SII. revisa tu internet y vuelve a intentar.');
        throw error;
      }

      this.msgBackdrop = 'REGISTRANDO VENTA';

      const ventaDTE = this.armarVenta(this.service.folio.actual, formaPago, xml64, result.trackId);
      await this.service.registrarVenta(ventaDTE);

      this.msgBackdrop = 'ACTUALIZANDO FOLIOS';

      await this.service.actualizarFolios(39, this.service.folio.actual + 1);

      this.cargando = false;
      this.salirVenta();

    } catch (error) {
      console.log(error);
      this.cargando = false;
    }
  }
}
